import { render } from "./schools-welcome.vue?vue&type=template&id=12cc6135"
import script from "./schools-welcome.js?vue&type=script&lang=js"
export * from "./schools-welcome.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__